import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../../shared/dialog/dialog.component';
import { Router } from '@angular/router';
import { Auth0Service } from "src/app/authentication/auth0/auth0.service";
@Component({
  selector: 'app-dialog',
  templateUrl: 'blue-button.component.html',
  styleUrls: ['blue-button.component.css'],
})
export class BlueButtonComponent implements OnInit {

  constructor(private dialog: MatDialog, private router: Router, private auth0 : Auth0Service) { }

  ngOnInit() {
    this.auth0.handleAuthentication();
    // this.openDialog();
  }

  openDialog() {
    this.auth0.handleAuthentication()
    const dialogRef = this.dialog.open(DialogComponent, {
      width: "620px",
      data: {
      }
    });
    dialogRef.componentInstance.btnAction.subscribe(result => {
      console.log("popup clicked")
      this.router.navigateByUrl('/app/dashboard');
    });
  }

}
